import React from "react";
import Button from "../../DesignSystem/button";
import clsx from "clsx";
import EditIcon from "../../../assets/images/edit-icon.svg";
import SoldIcon from "../../../assets/images/sold-icon.svg";
import InUseIcon from "../../../assets/images/in-use-icon.svg";
import { getDateInMediumFormat, wrapInTooltip } from "../../../utils/methods";
import { Tooltip } from "@material-ui/core";
interface marketplaceInterface {
  port: any;
  handleSale: () => void;
  removeLoadingId: string;
  isAdmin: boolean;
  cancelSubLoading: string;
  handleRemove: () => void;
  handleEdit: () => void;
  handleCancel: () => void;
}

const MarketplaceButton: React.FC<marketplaceInterface> = ({
  port,
  handleSale,
  removeLoadingId,
  handleCancel,
  isAdmin,
  cancelSubLoading,
  handleRemove,
  handleEdit,
}) => {
  const hasCrossConnect = port.crossConnectPortId || port.cross_connect_port_id;
  if (hasCrossConnect && !(port.status === "bought_port" && !port.purchasePortId)) {
    return <img src={InUseIcon} alt="In Use" />;
  } else if (!port.status) {
    // OFF NET SELLING PORT
    return <Button disabled={!port.verified && port.parent_id} className="btn-sale" variant="success" node="Sell" onClick={handleSale} />;
  } else if (port.status === "port_put_up_for_sale") {
    return (
      <>
        <Button
          className="btn-remove-from-market-place"
          variant="success"
          node="Remove"
          loading={!!(removeLoadingId === port.listing_id)}
          onClick={handleRemove}
        />
        <Tooltip
          placement="right"
          title="Edit Listing"
          classes={{
            tooltip: "tooltip",
          }}
          arrow
        >
          <img className="edit-icon" src={EditIcon} alt="Edit" onClick={handleEdit} />
        </Tooltip>
      </>
    );
  } else if (port.status === "bought_port" && port.purchasePortId) {
    if (port.price_type && port.price_type.includes("on_demand")) {
      return (
        <Button
          className="btn-cancel-subscription"
          variant="success"
          onClick={handleCancel}
          loading={!!(cancelSubLoading === port.purchasePortId)}
          node="Release"
        />
      );
    } else if (port.on_contract_price > 0 && port.days_until_contract_expire > 0) {
      const text = `Expires on ${getDateInMediumFormat(port.expiring_date)}`;
      return (
        <Button
          className={clsx("btn-cancel-subscription small", !isAdmin && "disabled")}
          variant="success"
          onClick={handleCancel}
          disabled={!isAdmin}
          loading={!!(cancelSubLoading === port.purchasePortId)}
          node={text}
        />
      );
    } else if (port.on_contract_price > 0) {
      return (
        <Button
          className="btn-cancel-subscription"
          variant="success"
          onClick={handleCancel}
          loading={!!(cancelSubLoading === port.purchasePortId)}
          node="Cancel"
        />
      );
    } else {
      return (
        <Button
          className="btn-cancel-subscription"
          variant="success"
          onClick={handleCancel}
          disabled
          loading={!!(cancelSubLoading === port.purchasePortId)}
          node="Unexpected"
        />
      );
    }
  } else if (port.status === "bought_port" && !port.purchasePortId) {
    return wrapInTooltip(<img src={SoldIcon} alt="Sold" />, `Sold to ${port.buyer_organization}`);
  }
  return <div>Hi</div>;
};
export default MarketplaceButton;
